import {
  Backend,
  getQueryParamValue,
  OrderByDirection,
} from '@freelancer/datastore/core';
import { PostFilesCollection } from './post-files.types';

export function postFilesBackend(): Backend<PostFilesCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.DESC,
    },
    fetch: (authUid, ids, query, order) => {
      const fileIds = getQueryParamValue(query, 'fileId');
      if (!fileIds) {
        throw new Error(
          "Undefined fileIds was given during fetching the post's files",
        );
      }
      return {
        endpoint: `posts/0.1/files`,
        isGaf: false,
        params: {
          file_ids: fileIds,
        },
      };
    },
    push: undefined,
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
